import { useState, useEffect } from 'react'
import KRGlue from '@lyracom/embedded-form-glue'

const NotificationIziPay = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const formToken = urlParams.get('formToken')
        const processId = urlParams.get('processId')

        if (formToken) {
            const endpoint = 'https://static.micuentaweb.pe/'
            const publicKey = '99815620:testpublickey_ZhGTNKXWW7oZOtskrGl9rFFj3MIQ2UJRWSpkfeEmuATaE'

            KRGlue.loadLibrary(endpoint, publicKey)
                .then(({ KR }) => KR.setFormConfig({ formToken }))
                .then(({ KR }) => KR.removeForms())
                .then(({ KR }) => {
                    KR.onSubmit(function (response) {
                        if (response.clientAnswer.orderStatus === "PAID") {
                            window.parent.postMessage({ type: 'paymentSuccess', processId: processId }, '*')
                            window.close()
                        } else {
                            console.error('Pago fallido:', response.clientAnswer.orderStatus)
                        }
                    })
                    return KR.renderElements('#paymentForm')
                })
                .catch(error => console.error("Error al configurar el formulario de pago:", error))
        }
    }, [])

    return (
        <div className="form">
            <div className="container">
                <div id="paymentForm">
                    <div className="kr-smart-form" kr-card-form-expanded></div>
                </div>
            </div>
        </div>
    )
}

export default NotificationIziPay
